<table>
  <thead>
    <tr>
      @for (column of columnNames; track column) {
        <th>
          {{ column | async }}
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (model of rows; track model) {
      <tr>
        <td>
          <a (click)="openDetail.emit(model.definitionGuid)">
            {{ (model.definitionResource | async)?.[myEnv.Attributes.DisplayName] }}
          </a>
        </td>

        <td>{{ model.type }}</td>
        <td>{{ model.status | async }}</td>
        <td>{{ model.statusDetail | async }}</td>
      </tr>
    }
    @if (rows.length === 0) {
      <tr>
        <td colspan="4" class="text-center">
          <language key="EmptyList" defaultValue="No items."></language>
        </td>
      </tr>
    }
  </tbody>
</table>
